import moment from 'moment';
import manageSignatureModal from './modals/manage-signature/manage-signature.component';
import manageLateEntryReasonsModal from './modals/manage-late-entry-reasons/manage-late-entry-reasons.component';
import manageAvatarModal from './modals/manage-avatar/manage-avatar.component';

class ProfileController {

  constructor(AuthenticationService, CompanyService, toastr, toastrConfig, $scope, $http, $rootScope, $uibModal) {
    "ngInject";
    this.authenticationService = AuthenticationService;
    this.name = 'profile';
    this.$http = $http;
    this.$scope = $scope;
    this.$rootScope = $rootScope;

    this.user = this.authenticationService.user;
    this.profileUrl = $rootScope.apiHost+"/api/users/me/avatar";
    this.avatarExists = false;
    this.avatarUrl = null;
    this.signatureExists = false;
    this.signatureUrl = null;
    this.signatureLoading = true;

    this.company = {};
    let self = this;
    this.anniversaryProgress = 65;
    this.toastr = toastr;
    this.toastrConfig = toastrConfig;

    // Store original values for comparison (before x-editable updates them)
    this.originalAddress = null;
    this.originalPhone = null;

    // Charge codes pagination and sorting
    this.chargeCodesPageSize = 5;
    this.chargeCodesCurrentPage = 1;
    this.chargeCodesSortColumn = null;
    this.chargeCodesSortDirection = 'asc';

    // Late entry reasons pagination and sorting
    this.reasonsPageSize = 5;
    this.reasonsCurrentPage = 1;
    this.reasonsSortColumn = null;
    this.reasonsSortDirection = 'asc';

    // Store the original toastr configuration for restoration
    this.originalToastrPosition = toastrConfig.positionClass;
    this.originalToastrTimeOut = toastrConfig.timeOut;
    this.originalToastrExtendedTimeOut = toastrConfig.extendedTimeOut;
    
    // Change toastr configuration for this page
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.timeOut = 1000; // 1 second
    toastrConfig.extendedTimeOut = 1000; // 1 second

    // Also listen for scope destruction as a fallback
    $scope.$on('$destroy', () => {
      this.restoreToastrConfig();
    });

    this.$http.get(this.$rootScope.apiHost+"/api/users/me",{withCredentials: true} ).then(
      function(response) {
        self.user = response.data;
        self.employeeStartDate = moment(self.user.startDate).format("MMMM DD, YYYY");
        self.old_pfpPath = self.user.pfpPath;
        self.address = self.user.address;
        self.phone = self.user.phone;

        // Initialize profile pic timestamp if not already set
        if (!self.$rootScope.profilePicTimeStamp) {
          self.$rootScope.profilePicTimeStamp = (new Date()).getTime();
        }

        // Avatar management is now handled by the modal
        // No need to set up file input event listener here

        // Test avatar URL to see if it exists
        self.loadAvatarUrl();
        
        // Test signature URL to see if it exists
        self.loadSignatureUrl();

      },
      function(response) {
        self.user = undefined;
      });

    this.modal = $uibModal;
  }

  getAvatarUrl() {
    return this.avatarUrl;
  }

  updateAvatar() {
    let profilePic = this.fileObject.files[0];

    let config = {
      headers: {
        'Content-Type': undefined
      },
      withCredentials: true,
      transformRequest: angular.identity
    };

    let self = this;

    var fd = new FormData();
    fd.append('file', profilePic);
    return this.$http.post(this.$rootScope.apiHost+"/api/users/me/avatar", fd, config).then(function (success) {
        self.authenticationService.refreshUser().then(function (success) {
            self.toastr.success("Your avatar was updated successfully.", "Avatar Updated!");
            self.newProfilePic = null;
            self.$rootScope.profilePicTimeStamp = (new Date()).getTime();
            self.user = self.authenticationService.user;
        });

    }, function (failure) {

    });
  }


 
  loadAvatarUrl() {
    let self = this;
    const avatarUrl = this.$rootScope.apiHost+"/api/users/me/avatar";
    
    // Test the URL with a HEAD request to check if it exists
    this.$http.get(avatarUrl, {withCredentials: true})
      .then(function(response) {
        // Success - avatar exists
        self.avatarExists = true;
        self.avatarUrl = avatarUrl;
      })
      .catch(function(error) {
        // 404 or other error - avatar doesn't exist
        if (error.status === 404) {
          self.avatarExists = false;
          self.avatarUrl = null;
        } else {
          // Other error - assume it doesn't exist for now
          self.avatarExists = false;
          self.avatarUrl = null;
        }
      });
  }

  resetPfpPath() {
    this.newProfilePic = null;
  }

  setPath() {
    let url = URL.createObjectURL(this.fileObject.files[0]);
    document.getElementById("profileImage").src = url;
    this.newProfilePic = url;
    this.$scope.$apply();
  }

  deleteAvatar() {
    let self = this;
    return this.$http.delete(this.$rootScope.apiHost+"/api/users/me/avatar", {withCredentials: true}).then(function (success) {
      self.authenticationService.refreshUser().then(function (success) {
        self.toastr.success("Your avatar was updated successfully.", "Avatar Updated!");
        self.user = self.authenticationService.user;
      });

    }, function (failure) {

    });
  }

  uploadFile() {
    // Open the manage avatar modal instead of directly uploading
    this.manageAvatar();
  }

  manageAvatar() {
    const modalInstance = this.modal.open(manageAvatarModal);
    // Pass the current avatar URL and status
    // Only pass URL if user has a profile pic and we can generate a valid URL
    let avatarUrl = null;
    if (this.avatarExists) {
      avatarUrl = this.getAvatarUrl();
    }
    modalInstance.currentAvatarUrl = avatarUrl;
    modalInstance.hasExistingAvatar = !!this.avatarExists;

    modalInstance.result.then((updated) => {
      if (updated) {
        // Refresh user data to get updated avatar
        this.authenticationService.refreshUser().then(() => {
          this.user = this.authenticationService.user;
          // Update timestamp to force refresh
          this.$rootScope.profilePicTimeStamp = (new Date()).getTime();
          // Reload avatar URL to check if it exists
          this.loadAvatarUrl();
          // Broadcast event to refresh avatar in header component
          this.$rootScope.$broadcast('avatarUpdated');
        });
      }
    }, () => {
      // Modal dismissed, do nothing
    });
  }

  uploadSignature() {
    const modalInstance = this.modal.open(manageSignatureModal);
    modalInstance.previewSignature = this.signatureExists ? this.getSignatureUrl() : null;
    modalInstance.hasExistingSignature = !!this.signatureExists;

    modalInstance.result.then((updated) => {
      if (updated) {
        this.authenticationService.refreshUser().then(() => {
          this.user = this.authenticationService.user;
          // Update timestamp to force refresh
          this.$rootScope.signatureTimeStamp = (new Date()).getTime();
          // Reload signature URL to check if it exists
          this.loadSignatureUrl();
        });
      }
    }, () => {});
  }

  updatePhoneNumber(){

  }

  updateDefaultChargeCode(chargeCode) {
    let self = this;
    return this.$http.put(this.$rootScope.apiHost+"/api/users/me/chargecodes/"+chargeCode.id+"/"+chargeCode.defaultCode, this.address , {withCredentials: true}).then(function (success) {
      self.authenticationService.refreshUser().then(function (success) {
        self.toastr.success("Your charge code request was processed successfully.", "Charge Code Updated!");
        self.user = self.authenticationService.user;
        self.address = self.user.address;
      });

    }, function (failure) {
      self.authenticationService.refreshUser().then(function (success) {
        self.toastr.error("There was a problem processing your request.", "ERROR!");
        self.user = self.authenticationService.user;
        self.address = self.user.address;
      });
    });



  }

  storeOriginalAddress(newValue) {
    // Store the current address before x-editable updates it
    // This is called in onbeforesave, so the model hasn't been updated yet
    this.originalAddress = this.user.address || '';
    return true; // Allow the save to continue
  }

  storeOriginalPhone(newValue) {
    // Store the current phone before x-editable updates it
    // This is called in onbeforesave, so the model hasn't been updated yet
    this.originalPhone = this.user.phone || '';
    return true; // Allow the save to continue
  }

  updateAddress(newAddress) {
    let self = this;
    // Use the new address value passed from x-editable
    const addressToSave = newAddress !== undefined ? newAddress : (this.user.address || '');
    
    // Get the original address value that we stored in onbeforesave
    const originalAddress = this.originalAddress !== null ? this.originalAddress : (this.user.address || '');
    
    // Check if the address actually changed (compare trimmed values)
    const trimmedNewAddress = (addressToSave || '').trim();
    const trimmedOriginalAddress = (originalAddress || '').trim();
    
    // Reset the stored original value
    this.originalAddress = null;
    
    if (trimmedNewAddress === trimmedOriginalAddress) {
      // No change, don't make API call or show toast
      return;
    }
    
    return this.$http.post(this.$rootScope.apiHost+"/api/users/me/address", addressToSave , {withCredentials: true}).then(function (success) {
      self.authenticationService.refreshUser().then(function (success) {
        self.toastr.success("Your address was updated successfully.", "Address Updated!");
        self.user = self.authenticationService.user;
        // Update the local address variable if it exists
        if (self.address !== undefined) {
        self.address = self.user.address;
        }
      });

    }, function (failure) {
      // On failure, refresh user to revert to original address
      self.authenticationService.refreshUser().then(function (success) {
        self.user = self.authenticationService.user;
        if (self.address !== undefined) {
          self.address = self.user.address;
        }
      });
    });
  }

  updatePhone(newPhone) {
    let self = this;
    // Use the new phone value passed from x-editable
    const phoneToSave = newPhone !== undefined ? newPhone : (this.user.phone || '');
    
    // Get the original phone value that we stored in onbeforesave
    const originalPhone = this.originalPhone !== null ? this.originalPhone : (this.user.phone || '');
    
    // Check if the phone number actually changed (compare trimmed values)
    const trimmedNewPhone = (phoneToSave || '').trim();
    const trimmedOriginalPhone = (originalPhone || '').trim();
    
    // Reset the stored original value
    this.originalPhone = null;
    
    if (trimmedNewPhone === trimmedOriginalPhone) {
      // No change, don't make API call or show toast
      return;
    }
    
    return this.$http.post(this.$rootScope.apiHost+"/api/users/me/phone", phoneToSave , {withCredentials: true}).then(function (success) {
      self.authenticationService.refreshUser().then(function (success) {
        self.toastr.success("Your phone number was updated successfully.", "Phone Number Updated!");
        self.user = self.authenticationService.user;
        // Update the local phone variable if it exists
        if (self.phone !== undefined) {
        self.phone = self.user.phone;
        }
      });

    }, function (failure) {
      // On failure, refresh user to revert to original phone number
      self.authenticationService.refreshUser().then(function (success) {
        self.user = self.authenticationService.user;
        if (self.phone !== undefined) {
          self.phone = self.user.phone;
        }
      });
    });
  }


  manageLateEntryReasons() {
    const modalInstance = this.modal.open(manageLateEntryReasonsModal);
    // Pass the current reasons to the modal
    modalInstance.reasons = angular.copy(this.user.lateEntryReasons || []);

    modalInstance.result.then((updated) => {
      if (updated) {
        // Refresh user data to get updated reasons
        this.authenticationService.refreshUser().then(() => {
          this.user = this.authenticationService.user;
          // Reset pagination to first page after update
          this.reasonsCurrentPage = 1;
        });
      }
    }, () => {
      // Modal dismissed, do nothing
    });
  }

  // Late Entry Reasons pagination and sorting methods
  getLateEntryReasons() {
    if (!this.user || !this.user.lateEntryReasons) {
      return [];
    }

    // Create a shallow copy of the array for sorting (but keep references to original objects)
    let reasons = (this.user.lateEntryReasons || []).slice();

    // Apply sorting
    if (this.reasonsSortColumn) {
      reasons.sort((a, b) => {
        let aVal, bVal;

        if (this.reasonsSortColumn === 'value') {
          aVal = (a.value || '').toLowerCase();
          bVal = (b.value || '').toLowerCase();
    } else {
          aVal = a[this.reasonsSortColumn] || '';
          bVal = b[this.reasonsSortColumn] || '';
        }

        // Handle null/undefined values
        if (aVal == null && bVal == null) return 0;
        if (aVal == null) return 1;
        if (bVal == null) return -1;

        // Compare values
        if (aVal < bVal) return this.reasonsSortDirection === 'asc' ? -1 : 1;
        if (aVal > bVal) return this.reasonsSortDirection === 'asc' ? 1 : -1;
        return 0;
      });
    }

    // Apply pagination
    const startIndex = (this.reasonsCurrentPage - 1) * this.reasonsPageSize;
    const endIndex = startIndex + this.reasonsPageSize;
    return reasons.slice(startIndex, endIndex);
  }

  getReasonsTotalPages() {
    if (!this.user || !this.user.lateEntryReasons) {
      return 0;
    }
    return Math.ceil((this.user.lateEntryReasons || []).length / this.reasonsPageSize);
  }

  getReasonsTotalItems() {
    if (!this.user || !this.user.lateEntryReasons) {
      return 0;
    }
    return (this.user.lateEntryReasons || []).length;
  }

  sortReasons(column) {
    if (this.reasonsSortColumn === column) {
      // Toggle sort direction
      this.reasonsSortDirection = this.reasonsSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // New column, default to ascending
      this.reasonsSortColumn = column;
      this.reasonsSortDirection = 'asc';
    }
    // Reset to first page when sorting changes
    this.reasonsCurrentPage = 1;
  }

  getReasonsSortClass(column) {
    if (this.reasonsSortColumn !== column) {
      return 'fa-sort';
    }
    return this.reasonsSortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  nextReasonsPage() {
    const totalPages = this.getReasonsTotalPages();
    if (this.reasonsCurrentPage < totalPages) {
      this.reasonsCurrentPage++;
    }
  }

  prevReasonsPage() {
    if (this.reasonsCurrentPage > 1) {
      this.reasonsCurrentPage--;
    }
  }

  getSignatureUrl() {
    return this.signatureUrl;
  }

  loadSignatureUrl() {
    let self = this;
    const signatureUrl = this.$rootScope.apiHost+"/api/users/me/signature";
    this.signatureLoading = true;
    
    // Test the URL with a GET request to check if it exists
    this.$http.get(signatureUrl, {withCredentials: true})
      .then(function(response) {
        // Success - signature exists
        self.signatureExists = true;
        self.signatureUrl = signatureUrl;
        self.signatureLoading = false;
      })
      .catch(function(error) {
        // 404 or other error - signature doesn't exist
        if (error.status === 404) {
          self.signatureExists = false;
          self.signatureUrl = null;
        } else {
          // Other error - assume it doesn't exist for now
          self.signatureExists = false;
          self.signatureUrl = null;
        }
        self.signatureLoading = false;
      });
  }

  // Charge Codes pagination and sorting methods
  getChargeCodes() {
    if (!this.user || !this.user.availableChargeCodes) {
      return [];
    }

    // Create a shallow copy of the array for sorting (but keep references to original objects)
    let chargeCodes = this.user.availableChargeCodes.slice();

    // Apply sorting
    if (this.chargeCodesSortColumn) {
      chargeCodes.sort((a, b) => {
        let aVal, bVal;

        // Handle validity column (sort by effective date, then expiration date)
        if (this.chargeCodesSortColumn === 'validity') {
          aVal = a.effectiveDate ? new Date(a.effectiveDate) : new Date(0);
          bVal = b.effectiveDate ? new Date(b.effectiveDate) : new Date(0);
          // If effective dates are equal, compare expiration dates
          if (aVal.getTime() === bVal.getTime()) {
            aVal = a.expirationDate ? new Date(a.expirationDate) : new Date(0);
            bVal = b.expirationDate ? new Date(b.expirationDate) : new Date(0);
          }
        } else {
          aVal = a[this.chargeCodesSortColumn];
          bVal = b[this.chargeCodesSortColumn];

          // Handle dates
          if (this.chargeCodesSortColumn === 'effectiveDate' || this.chargeCodesSortColumn === 'expirationDate') {
            aVal = aVal ? new Date(aVal) : new Date(0);
            bVal = bVal ? new Date(bVal) : new Date(0);
          }
        }

        // Handle null/undefined values
        if (aVal == null && bVal == null) return 0;
        if (aVal == null) return 1;
        if (bVal == null) return -1;

        // Compare values
        if (aVal < bVal) return this.chargeCodesSortDirection === 'asc' ? -1 : 1;
        if (aVal > bVal) return this.chargeCodesSortDirection === 'asc' ? 1 : -1;
        return 0;
      });
    }

    // Apply pagination
    const startIndex = (this.chargeCodesCurrentPage - 1) * this.chargeCodesPageSize;
    const endIndex = startIndex + this.chargeCodesPageSize;
    return chargeCodes.slice(startIndex, endIndex);
  }

  getValidityDisplay(chargeCode) {
    const effectiveDate = chargeCode.effectiveDate || '';
    const expirationDate = chargeCode.expirationDate || '';
    
    if (effectiveDate && expirationDate) {
      return effectiveDate + ' - ' + expirationDate;
    } else if (effectiveDate) {
      return effectiveDate + ' - ';
    } else if (expirationDate) {
      return ' - ' + expirationDate;
    } else {
      return '-';
    }
  }

  getChargeCodesTotalPages() {
    if (!this.user || !this.user.availableChargeCodes) {
      return 0;
    }
    return Math.ceil(this.user.availableChargeCodes.length / this.chargeCodesPageSize);
  }

  getChargeCodesTotalItems() {
    if (!this.user || !this.user.availableChargeCodes) {
      return 0;
    }
    return this.user.availableChargeCodes.length;
  }

  sortChargeCodes(column) {
    if (this.chargeCodesSortColumn === column) {
      // Toggle sort direction
      this.chargeCodesSortDirection = this.chargeCodesSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // New column, default to ascending
      this.chargeCodesSortColumn = column;
      this.chargeCodesSortDirection = 'asc';
    }
    // Reset to first page when sorting changes
    this.chargeCodesCurrentPage = 1;
  }

  getChargeCodesSortClass(column) {
    if (this.chargeCodesSortColumn !== column) {
      return 'fa-sort';
    }
    return this.chargeCodesSortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  goToChargeCodesPage(page) {
    const totalPages = this.getChargeCodesTotalPages();
    if (page >= 1 && page <= totalPages) {
      this.chargeCodesCurrentPage = page;
    }
  }

  nextChargeCodesPage() {
    const totalPages = this.getChargeCodesTotalPages();
    if (this.chargeCodesCurrentPage < totalPages) {
      this.chargeCodesCurrentPage++;
    }
  }

  prevChargeCodesPage() {
    if (this.chargeCodesCurrentPage > 1) {
      this.chargeCodesCurrentPage--;
    }
  }

  restoreToastrConfig() {
    // Restore the original toastr configuration when leaving the profile page
    if (this.toastrConfig) {
      if (this.originalToastrPosition !== undefined) {
        this.toastrConfig.positionClass = this.originalToastrPosition;
      }
      if (this.originalToastrTimeOut !== undefined) {
        this.toastrConfig.timeOut = this.originalToastrTimeOut;
      }
      if (this.originalToastrExtendedTimeOut !== undefined) {
        this.toastrConfig.extendedTimeOut = this.originalToastrExtendedTimeOut;
      }
    }
  }

  $onDestroy() {
    // Restore the original toastr configuration when component is destroyed
    this.restoreToastrConfig();
  }

}

export default ProfileController;



// WEBPACK FOOTER //
// ./client/pages/profile/profile.controller.js